import React from 'react';
import { Input as AntInput } from 'antd';
import cn from 'classnames';
import styles from './index.module.scss';

const typeKeys = {
  base: 'base',
  search: 'search',
};

const typeSet = new Set(Object.values(typeKeys));

const Input = ({ className, type, ...props }) => {
  const currentType = typeSet.has(type) ? type : typeKeys.base;

  switch (currentType) {
    case typeKeys.base: {
      return <AntInput {...props} className={cn(styles.input, className)} />;
    }

    case typeKeys.search: {
      return (
        <AntInput.Search {...props} className={cn(styles.search, className)} />
      );
    }

    default: {
      return null;
    }
  }
};

Input.types = typeKeys;

export default Input;
